<div *ngIf="customer?.id" class="mf-data-group d-flex align-items-stretch">
    <div>
        <ng-container *ngIf="customerGuard; else elseTemplate">
            <div class="m-list-search__result-item m-input-icon py-0">
                <span class="m-list-search__result-item-icon">
                    <i ngbTooltip="Drug kontakt" class="la la-envelope-square m--font-inverse-light"></i>
                </span>
                <span class="m-list-search__result-item-text">
                    {{ customerGuard?.name }}
                    {{ customerGuard?.surname }}
                </span>
            </div>
            <div class="m-list-search__result-item m-input-icon py-0">
                <span class="m-list-search__result-item-icon">
                    <i class="la la-phone m--font-inverse-light"></i>
                </span>
                <span class="m-list-search__result-item-text">
                    {{ customerGuard?.phone }}
                </span>
            </div>
            <div class="m-list-search__result-item m-input-icon py-0">
                <span class="m-list-search__result-item-icon">
                    <i class="la la-at m--font-inverse-light"></i>
                </span>
                <span class="m-list-search__result-item-text">
                    {{ customerGuard?.email }}
                </span>
            </div>
        </ng-container>
        <ng-template #elseTemplate>
            <div class="m-list-search__result-item m-input-icon py-0">
                <span class="m-list-search__result-item-icon">
                    <i class="la la-phone m--font-inverse-light"></i>
                </span>
                <span class="m-list-search__result-item-text">
                    {{ customer?.phone }}
                </span>
            </div>
            <div class="m-list-search__result-item m-input-icon py-0">
                <span class="m-list-search__result-item-icon">
                    <i class="la la-at m--font-inverse-light"></i>
                </span>
                <span class="m-list-search__result-item-text">
                    {{ customer?.email }}
                </span>
            </div>
        </ng-template>
    </div>
    <div
        *ngIf="customer?.createdFrom === 'PATIENT_APP'"
        (click)="onFindSimilarCustomers.emit()"
        ngbTooltip="Potrdi/poveži novo stranko"
        class="mf-data-group-button rounded-0 d-flex align-items-center m--bg-fill-warning"
    >
        <i class="la la-user-plus m--font-light"></i>
    </div>
    <div *ngIf="!parent?.controls?.customer?.disabled" (click)="onOpenCustomerEditForm.emit()" class="mf-data-group-button d-flex align-items-center">
        <i class="la la-edit m--font-light"></i>
    </div>
</div>
